import { TProjectConfigurationParameter } from 'entries/common/widgets/project-configuration/context';
import { TAB_LIST } from 'pages/common/const';

export const getActiveTab = (
  projectConfigurationParameters: Array<TProjectConfigurationParameter> | undefined
): number => {
  let params: { [key: string]: string | null } = {
    width: null,
    length: null,
    area: null,
  };
  projectConfigurationParameters?.forEach(({ key, value }) => {
    if (Object.keys(params).includes(key)) {
      params[key] = value;
    }
  });

  if (params.area && !params.length && !params.width) {
    return TAB_LIST.AREA;
  }

  return TAB_LIST.LENGTH_WIDTH;
};
